<template>
  <Card :bordered="false" dis-hover>
    <p slot="title">
      <slot name="title"></slot>
    </p>
    <a href="#" slot="extra">
      <slot name="extra"></slot>
    </a>
    <Spin size="large" v-if="isLoading" fix></Spin>
    <Carousel
      v-model="swiperValue"
      class="ai-box"
      autoplay
      dots="none"
      arrow="never"
      :autoplay-speed="5000"
    >
      <CarouselItem
        v-for="(item, index) in aiList"
        :key="index"
        style="width: 420px; height: 100%"
      >
        <div class="row">
          <div class="row-item" v-for="(it, i) in item" :key="i">
            <img class="row-img" :src="it.imgUrl" alt="" />
            <div class="row-tag">
              <img
                class="tag-icon"
                src="../../../../public/images/home/ico_AI.png"
                alt=""
              />
              <span class="tag-name">{{ it.labelNames }}</span>
            </div>
            <div class="row-font">{{ it.createTime }}</div>
            <div class="row-font">{{ it.depName }}</div>
          </div>
        </div>
      </CarouselItem>
    </Carousel>
  </Card>
</template>

<script>
import api from '../../../api/home/index';
export default {
  data() {
    return {
      aiList: [],
      swiperValue: 0,
      isLoading: true,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      api.queryAbnormalTaskLogList().then(res => {
        if (res.length) {
          let result = [];
          for (var i = 0; i < res.length; i += 2) {
            result.push(res.slice(i, i + 2));
          }
          this.aiList = result;
        }

        this.isLoading = false;
      });
    },
  },
};
</script>
<style lang="scss">
.ai-box {
  width: 100%;
  height: 100%;
  .row {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: nowrap;
  }
  .row-item {
    width: 240px;
    height: 100%;
    margin-right: 24px;

    .row-img {
      width: 100%;
      height: 135px;
      border-radius: 8px;
    }
    .row-tag {
      display: flex;
      margin: 8px 0;
      .tag-icon {
        width: 21px;
        height: 21px;
      }
      .tag-name {
        font-weight: 600;
        font-size: 16px;
        color: #3c59ff;
        margin-left: 3.5px;
      }
    }
    .row-font {
      font-weight: 400;
      font-size: 13px;
      color: #7f7f7f;
    }
  }
}
</style>
